import { useSelector, shallowEqual } from 'react-redux';
import { selectors, verifiers } from '@yola/subscription-manager-js';
import extraPrices from '../constants/extra-price-types';
import useFeatureFlags from '../../feature-flags/hooks/use-feature-flags';
import useAvailablePlatformComponents from '../../user/hooks/use-available-platform-components';
import platformComponents from '../../user/constants/platform-components';

function useDomainsExtraPrice(isFreeTrialAvailable = false) {
  const subscriptionsList = useSelector(selectors.getSubscriptionList, shallowEqual);
  const activeSubscriptions = useSelector(selectors.getActiveSubscriptions, shallowEqual);
  const activeHostingSubscription = useSelector(selectors.getActiveHostingSubscription);

  const [featureFlags] = useFeatureFlags(['freedomain', 'free_trial_upsell']);
  const availablePlatformComponents = useAvailablePlatformComponents();

  const { freedomain: isFreeDomainFlagEnabled, free_trial_upsell: isFreeTrialUpsellEnabled } =
    featureFlags;
  const isDomainsPlatformAvailable = availablePlatformComponents.includes(
    platformComponents.DOMAINS
  );

  if (
    !subscriptionsList ||
    !activeSubscriptions ||
    !isDomainsPlatformAvailable ||
    (!isFreeDomainFlagEnabled && !isFreeTrialUpsellEnabled)
  )
    return null;

  const hasEverHadDomainSubscription = subscriptionsList.some(({ type }) =>
    verifiers.isDomainPackageType(type)
  );

  if (hasEverHadDomainSubscription) {
    return null;
  }

  const hasAnnualPaidHostingSubscription =
    verifiers.hasAnnualPaidHostingSubscription(activeSubscriptions);

  if (hasAnnualPaidHostingSubscription) {
    return extraPrices.NO_DISCOUNTS;
  }

  const isActiveSubscriptionTrial =
    activeHostingSubscription && verifiers.isTrialSubscription(activeHostingSubscription);
  const isAnnualTrialPackageAvailable = isFreeTrialAvailable || isActiveSubscriptionTrial;

  if (isAnnualTrialPackageAvailable) {
    return extraPrices.ANNUAL_TRIAL_PACKAGE;
  }

  return extraPrices.FREE_COM_DOMAIN;
}

export default useDomainsExtraPrice;
